var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "skpfull_wrap", attrs: { id: "wrap" } }, [
    _c("div", { staticClass: "rd_box register" }, [
      _c("div", { staticClass: "container register step2" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "content", attrs: { "ng-init": "" } }, [
          _c("div", { staticClass: "one-register" }, [
            _c("div", { staticClass: "input-rows" }, [
              _c("fieldset", { staticClass: "step_set" }, [
                _c("div", { staticClass: "one-input-container" }, [
                  _c("label", [_vm._v("국가")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.countryCd,
                        expression: "countryCd"
                      }
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.countryCd },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.countryCd = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "one-input-container" }, [
                  _c("label", [_vm._v("언어")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.langCdd,
                        expression: "langCdd"
                      }
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.langCdd },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.langCdd = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "one-input-container" }, [
                  _c("label", [_vm._v("제목")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.title,
                        expression: "title"
                      }
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.title },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.title = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "one-input-container" }, [
                  _c("label", { attrs: { for: "idCont" } }, [
                    _vm._v("약관내용")
                  ]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.contents,
                        expression: "contents"
                      }
                    ],
                    attrs: { id: "idConst", rows: "20" },
                    domProps: { value: _vm.contents },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.contents = $event.target.value
                      }
                    }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "one-btn-wrap" }, [
              _c(
                "button",
                { staticClass: "bt-type-b next", on: { click: _vm.saveTerms } },
                [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.SAVE")))]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h1", [_vm._v("Insert Terms & Conditions")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ddc172c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ddc172c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/eur/user/InsertTermsCond.vue
// module id = sZNO
// module chunks = 0